import Cookies from "js-cookie";
import React, { useEffect } from "react";
import S from "./CookieConsent.style";
import useCookieConsentData from "./useCookieConsentData";
import { Script } from "gatsby-script";

const CookieConsent = () => {
  const cookieConsent = useCookieConsentData();
  const [isOpen, setIsOpen] = React.useState(true);
  const cookieValue = Cookies.get("cookieConsent");

  React.useEffect(() => setIsOpen(cookieValue !== "true"), [cookieValue]);
  const enableAnalytics = () => {
    Cookies.set("cookieConsent", "true"),
      {
        sameSite: "lax",
        secure: "true",
        expires: 365,
      };
    setIsOpen(false);
  };

  const { paragraph, link, label } = cookieConsent;

  return (
    <>
      {isOpen ? (
        <S.Container>
          {paragraph && <S.Paragraph>{paragraph}</S.Paragraph>}
          <S.Wrapper>
            <S.Button onClick={enableAnalytics}>{label}</S.Button>
            {link && (
              <S.Button>
                <S.A to={link.url}>{link.title}</S.A>
              </S.Button>
            )}
          </S.Wrapper>
        </S.Container>
      ) : null}

      {cookieValue === "true" && (
        <>
          <Script>
            {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-PDMWQBB')
          `}
          </Script>

          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-PDMWQBB"
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
            ></iframe>
          </noscript>
          <Script
            type="text/javascript"
            id="hs-script-loader"
            async
            defer
            src="//js.hs-scripts.com/7060239.js"
          />
        </>
      )}
    </>
  );
};

export default CookieConsent;
